import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormClients } = Forms
        const { onResetForm } = FormClients

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllClients = async () => {

        const { fetchAllClients } = FetchData
        const { executeFetchAllClients } = fetchAllClients

        executeFetchAllClients()

    }

    const handleClickFetchInfoClient = async (idcliente) => {
        
        const { FormClients: {onResetForm} } = Forms

        const { fetchInfoClient } = FetchData
        const { setParamsToSearch, executeFetchInfoClient } = fetchInfoClient

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idcliente: idcliente})
        executeFetchInfoClient()

        handleClickShowForm(true)

    }

    const handleClickEnableClient = async (idcliente) => {
        Swal.fire({
            title: '¿Está seguro de Activar este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados de clientes que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/clients/enable/${idcliente}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllClients()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDisableClient = async (idcliente) => {
        Swal.fire({
            title: '¿Está seguro de Desactivar este registro?',
            text: 'Esta acción hará que el registro sea removido de los listados de clientes que se encuentran en todo el sistema y no podrá asociar información a él',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/clients/disable/${idcliente}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllClients()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDeleteClient = async (idcliente) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/clients/delete/${idcliente}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllClients()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }
    
    const onSubmitFormClients = async (e) => {

        e.preventDefault()

        const { FormClients } = Forms
        const { formState, onResetForm } = FormClients

        const { getCurrentDate } = Helpers

        const _dataBody = {

            nombre: formState.nombre,
            apellido: formState.apellido,
            apellido_casado: formState.apellido_casado,
            direccion_dpi: formState.direccion_dpi,
            nit: formState.nit,
            profesion: formState.profesion,
            estado_civil: formState.estado_civil,
            nacionalidad: formState.nacionalidad,
            calle: formState.calle,
            sector: formState.sector,
            lote: formState.lote,
            seccion: formState.seccion,
            manzana: formState.manzana,
            colonia: formState.colonia,
            codigo_ingreso: formState.codigo_ingreso,
            zona: formState.zona,
            municipio: formState.municipio,
            departamento: formState.departamento,
            referencia: formState.referencia,
            direccion_2: formState.direccion_2,
            telefono: formState.telefono,
            dpi: formState.dpi,
            celular_1: formState.celular_1,
            celular_2: formState.celular_2,
            telefono_casa: formState.telefono_casa,
            telefono_trabajo: formState.telefono_trabajo,
            extension: formState.extension,
            correo: formState.correo,
            nombres_familiar_1: formState.nombres_familiar_1,
            parentesco_familiar_1: formState.parentesco_familiar_1,
            contacto_familiar_1: formState.contacto_familiar_1,
            nombres_familiar_2: formState.nombres_familiar_2,
            parentesco_familiar_2: formState.parentesco_familiar_2,
            contacto_familiar_2: formState.contacto_familiar_2,
            nombres_familiar_3: formState.nombres_familiar_3,
            parentesco_familiar_3: formState.parentesco_familiar_3,
            contacto_familiar_3: formState.contacto_familiar_3,
            nombres_personal_1: formState.nombres_personal_1,
            parentesco_personal_1: formState.parentesco_personal_1,
            contacto_personal_1: formState.contacto_personal_1,
            nombres_personal_2: formState.nombres_personal_2,
            parentesco_personal_2: formState.parentesco_personal_2,
            contacto_personal_2: formState.contacto_personal_2,
            nombres_personal_3: formState.nombres_personal_3,
            parentesco_personal_3: formState.parentesco_personal_3,
            contacto_personal_3: formState.contacto_personal_3,
            usuario_creo: user.username,
            fecha_creo: getCurrentDate()
        }

        if(formState.idcliente > 0){

            await marvarApi.put( `/clients/update/${formState.idcliente}`, {idcliente: formState.idcliente, ..._dataBody } )
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllClients()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/clients/create`, _dataBody )
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllClients()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllClients,
        handleClickFetchInfoClient,
        handleClickEnableClient,
        handleClickDisableClient,
        handleClickDeleteClient,
        onSubmitFormClients
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { title, data } = res
        if (title === 'OK') {
            toast.success(data.msg, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(data.msg, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}